export default "__VITE_ASSET__DXjxzVGI__"